__turbopack_context__.v({
  "defaultThree": "xoOxca_defaultThree",
  "defaultTwo": "xoOxca_defaultTwo",
  "drawer": "xoOxca_drawer",
  "four": "xoOxca_four",
  "items": "xoOxca_items",
  "loading": "xoOxca_loading",
  "one": "xoOxca_one",
  "three": "xoOxca_three",
  "two": "xoOxca_two",
});
